// internal deps
import { WALLET_OTP_LENGTH } from "@swiggy-private/payment-core";
import { format } from "@swiggy-private/core-ui";

// constants
import { TEXTS } from "@payment-ui/constants/index";

export const isValidCode = (value: string): value is keyof typeof WALLET_OTP_LENGTH => {
    return value in WALLET_OTP_LENGTH;
};

export const getLinkAccountTitle = (displayName: string): string => {
    return format(TEXTS.LINK_X_ACCOUNT, displayName);
};

export const getLinkAccountTitleV4 = (): string => {
    return TEXTS.ENTER_OTP_RECEIVED;
};
